
import React, { Fragment, useEffect, useState } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { useSelector } from "react-redux";
import { ServiceCallsApi } from "./api";
import ServiceCallGrid from "./ServiceCallGrid";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";

interface serviceCallsWidgetProps {
  id: string;
  header: string;
  machine?: String;
}

const SearchGridWidget = (props: serviceCallsWidgetProps) => {
  const [serviceCalls, updateserviceCalls] = useState(null);
  const [serviceCallsLoading, updateLoadingserviceCalls] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const globalParams = useSelector(getParamsSelector);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (
      globalParams.customerID != null &&
      globalParams.mainMachineSerialNo == null
    ) {
      updateLoadingserviceCalls(true);
      getServiceCalls(globalParams.customerID, signal);
    } else if (globalParams.mainMachineSerialNo != null) {
      updateLoadingserviceCalls(true);
      getMachineServiceCalls(globalParams.mainMachineSerialNo, signal);
    }
    return () => controller.abort();
  }, [globalParams.customerID, globalParams.mainMachineSerialNo]);

  const getServiceCalls = (cId, signal) => {
    let params: any = { customerId: cId };
    ServiceCallsApi.getCustomerServiceCalls(params, signal)
      .then((response: any) => {
        //console.log(response);
        updateserviceCalls(response);
        updateLoadingserviceCalls(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingserviceCalls(true);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };
  const getMachineServiceCalls = (machineSerial, signal) => {
    let params: any = { machineSerial: machineSerial };
    ServiceCallsApi.getMachineServiceCalls(params, signal)
      .then((response: any) => {
       // console.log(response);
        updateserviceCalls(response);
        updateLoadingserviceCalls(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingserviceCalls(true);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };

  if (serviceCallsLoading) {
    return <Spinner text="service calls" />;
  }
  if (errorMessage != null) {
    return (
      <>
        <br />
        <ErrorMessage
          text={"No data found"}
          id={props.id}
          header={props.header}
        />
      </>
    );
  }
  return <ServiceCallGrid data={serviceCalls} />;
};

export default SearchGridWidget;
